export default __webpack_public_path__ + "static/media/spr_sp_logo.f7f2a2fe.png";